var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") + "单号")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deviceAppturnVoucherInfo.no))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deviceAppturnVoucherInfo.retailerName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deviceAppturnVoucherInfo.comName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deviceAppturnVoucherInfo.warehouseName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") + "日期")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deviceAppturnVoucherInfo.theDate))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deviceAppturnVoucherInfo.createTime))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deviceAppturnVoucherInfo.creatorName))
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.ioFlag == -1
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.deviceAppturnVoucherInfo.autoMaskAsIdle ? "是" : "否"
                    )
                  )
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.deviceAppturnVoucherInfo.assetType != 2 ? "资产" : "耗材"
            ) +
              _vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") +
              "信息"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "right" }, [
          _vm.shopDeviceAppturnItem != null
            ? _c("span", [
                _vm._v(
                  "已选择(" + _vm._s(_vm.shopDeviceAppturnItem.length) + ")"
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("swb-query-sort-area", {
        ref: "query_model_ctrl",
        attrs: {
          name: "query-sort-area",
          confKey: _vm.confKey,
          configAuto: true,
          onConfigReady: _vm.onResultConfigReady,
          queryHandler: _vm.queryHandler,
          popupHandler: _vm.popupHandler
        }
      }),
      _vm._v(" "),
      _c("swb-result-table", {
        ref: "result_table",
        attrs: {
          name: "result_table",
          confKey: _vm.resultKey,
          configAuto: true,
          needPager: _vm.needPager,
          multiSelect: _vm.multiSelect,
          multiPageSelect: _vm.multiPageSelect,
          rowKeyPropName: _vm.rowKeyPropName,
          rowNoShow: _vm.rowNoShow,
          rowNoFixed: _vm.rowNoFixed,
          height: _vm.tableHeight,
          pageNoChangeHandler: _vm.pageNoChangeHandler,
          rowDblClickHandler: _vm.rowDblClickHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建商户")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("仓库名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("自动标记闲置")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21af1564", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21af1564","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceAppturnVoucherInfo.vue
// module id = 3039
// module chunks = 0